<template>
    <div v-show="widget" class='notification_popup'  @mouseenter="showCloseIcon" @mouseleave="hiddenCloseIcon">
        <div class="notification_popup-close-wrap">
            <transition enter-active-class="animated fadeIn"
						    leave-active-class="animated fadeOut">
            <div v-show="close" class="notification_popup-close-ico" @click="closePopup">
                <i class="icon-close"></i>
            </div>
            </transition>
        </div>
        <scrollbar class="wrap">
        <div class="notification__zone">
            <div v-for="(item, index) in getPosistions" :key="index +'close'" class="notification_item">
                <close :positionData = "item"></close>
            </div>
        </div>
        </scrollbar>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import openPositionNoti from "./sig-notification-open-positions-minimaze"
import closePositionNoti from "./sig-notification-close-positions-minimaze"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    props: {
        currency:{default:''}
    },
    components: {
        'open':openPositionNoti,
        'close':closePositionNoti,
        'scrollbar':VuePerfectScrollbar,
    },
    data() {
        return {
            close:false,
            widget:true,
            show:true,
        }
    },
    computed: {
        ...mapGetters({
            getEvents:'accountevents/events',
            getStatusHeader:'usersets/getHeader'
        }),
        getPosistions() {
            let openClos = []

            if (this.currency === '') {
                for (let i=0; i < this.getEvents.length; i++)
                {
                    
                    openClos.push(this.getEvents[i]);
                    
                    //this.$emit('bell', true);
                }
            }
            else {
                for (let i=0; i < this.getEvents.length; i++)
                {
                    if(this.getEvents[i].symbol === this.currency) {
                        openClos.push(this.getEvents[i]);
                    }
                    //this.$emit('bell', true);
                }
            }
            //this.$emit('bell', true);
            return openClos;
        },
    
        nowDate() {
            let dateNow = new Date()
            return dateNow
        }
    },
    methods : {
        showCloseIcon() {
            this.close = true;
        },
        hiddenCloseIcon() {
            this.close = false;
        },
        closePopup() {
            this.widget = false;
        },
        /*getNoti(callback) {
            let divs = document.querySelectorAll('.notification_item');
            let parent = document.querySelector('.notification__zone');
            setTimeout(()=> {
                for(let i = 0; i < divs.length; i++) {
                    setTimeout( () => {
                        divs[i].classList.add('notification_item-fade');
                        setTimeout(() => {
                            divs[i].style.display = 'none';
                            if (divs[i].parentNode) {
                                divs[i].parentNode.removeChild(divs[i]);
                            }
                            //parent.appendChild(divs[i]);
                            //divs[i].classList.remove('notification_item-fade');
                            //divs[i].style.display = 'block';
                            //parent.insertBefore(divs[i], parent.children[5]);
                        },1700)
                    }, i*4000,i);
                }
            },5000)
            callback();
        } */
    },      
            
        
        /*signalNotification() {
            const myAudio = window.document.querySelector('audio').play();
            console.log(myAudio)
           // myAudio.src = (require("../../assets/sound/icq-aska.mp3"));
           // myAudio.autoplay = true
           // myAudio.play()
            if (myAudio !== undefined) {
            myAudio.then(_ => {
                //Auto
            }).catch(error => {
                //Error
            });
            }
        }*/
    
    mounted () {
            /*setInterval(()=> {
                if(this.getEvents.length !== null)
                   console.log(1);
            },1000)*/

           
           
    },
    created () {
        // this.$store.dispatch('accountevents/subscribeOnPositionEvents') // зачем, подписка уже есть
     
    }
}

</script>
<style lang="less" scoped>
@keyframes change-top { 
    from {
        top: 96px;
    }
    to {
        top: 48px;
    }
}
@keyframes change-top-full { 
    from {
        top: 48px;
    }
    to {
        top: 96px;
    }
}
@keyframes slideOut {
  from {
    transform: translateX(0px);
  }
  to {
    transform: translateX(-100vw);
  }
}
.notification_item-fade {
    animation: slideOut 4s forwards;
}
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active до версии 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}

.wrap {
    max-height: 100%;
    overflow: auto;
}
.notification_popup {
    height: 395px;
    z-index: 3;
    padding-bottom: 20px;
    /*background: #374b62;*/
    position: absolute;
    top: 170px;
    overflow: hidden;
    &-minimaze {
        animation: change-top 0.6s ease-in 1;
        top: 48px;
        height: calc(100vh - 48px);
    }
    &-close-wrap {
        width: 100%;
        height: 25px;
        margin-bottom: 5px;
        display: flex;
        justify-content: flex-end;
    }
    &-close-ico {
        //position: absolute;
        width: 25px;
        height: 25px;
        background: rgba(0,0,0,0.3);
        z-index: 1;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color:#fff;
        cursor: pointer;
        i {
            margin-right: 5px;
        }
    }
}
.notification__sidebar {
    display: flex;
    justify-content: space-between;
    padding: 0 16px 0 12px;
    background-color: #3d536b;
    font-family: Arimo;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 3.64;
    letter-spacing: 0.4px;
    color: #ffffff;
    text-transform: uppercase;
    max-height: 40px;
    box-shadow: 0 0 10px rgba(0,0,0,0.3);
    &_left-data {
        display: flex;
        justify-content: space-between;
        &-white {
            margin-right: 12px;
        }
        &-gray {
            color: #adc7e1;
            margin-right: 12px;
        }
    }
    &_right-data {
        color: #adc4e1;
        text-transform: none;
        display: flex;
        justify-content: space-between;
        &-date {
            margin-right: 12px;
        }
        &-ico-close {
            font-size: 18px;
            line-height: 1;
            padding-top: 10px;
            cursor: pointer;
        }
    }
}

.notification__zone {
    &_sub-wrapper {
        background-color: rgb(255, 254, 204);
        border-radius: 4px;
        margin: 12px 12px;
        width: 370px;
        box-shadow: 0 0 10px rgba(0,0,0,0.3);
    }
}

.notification_order {
    &-title {
        display: flex;
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        height: 30px;
        align-items: center;
        letter-spacing: 0.4px;
        text-align: left;
        color: #000;
        text-transform: uppercase;
        border-bottom: 1px solid #374b62;
        i {
            font-size: 14px;
            margin-left: auto;
            cursor: pointer;
            margin-right: 4px;
        }
        &-status {
            margin-left: 12px;
        }
        &-pair {
            margin-left: 12px;
        }
        &-number {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: #7a8088;
            margin-left: 12px;
        }
        &-day {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: #7a8088;
            margin-left: 12px;
        }
        &-time {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: #7a8088;
            margin-left: 12px;
        }
    }
    &-main_data {
        display: flex;
        padding: 4px 4px;
        border-bottom: 1px solid #374b62;
        &:last-child {
            border-bottom: none;
        }

        &-type_and_volume {
            
            &-data-type {
                display: flex;
            }
            &-img {
                height: 32px;
                font-size: 32px;
                padding-left: 4px;
                color:#000;
            }
            &-data {
                margin-left: 4px;
            }
        }
    }
    &-sub-title {
        font-family: Arimo;
        font-size: 10px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.6;
        letter-spacing: 0.4px;
        color: #7a8088;
        text-transform: uppercase;
    }
    &-sub-data {
        font-family: Arimo;
        font-size: 12px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.23;
        letter-spacing: 0.4px;
        text-align: left;
        color: #000;
        margin-right: 4px;
    }
    &-block_big {
        width: 176px;
        padding-left: 4px;
        box-sizing: border-box;
    }
    &-block_midle {
        width: 88px;
        padding-left: 4px;
        box-sizing: border-box;
    }
}
</style>

